<template>
  <TaskPage no-brand no-back no-action>
    <template #title>Upload my tree</template>
    <h5>How do you want to upload your tree?</h5>
    <div class="method-grid" :class="{ 'show-features': showFeaturesRef }">
      <button type="button" class="btn btn-choice card-file" @click="emit('choose-file')">
        <div class="method-title">Upload a file</div>
        <div class="method-subtitle"></div>
        <div class="method-icon">
          <img src="@/assets/icons/document.svg"/>
          <ArrowUpIcon/>
        </div>
      </button>
      <ul v-show="showFeaturesRef" class="method-features features-file list-unstyled">
        <li><CheckIcon size="20"/><span>FREE</span></li>
        <li><CheckIcon size="20"/><span>Nothing to install</span></li>
        <li><CheckIcon size="20"/><span>No export to GEDCOM</span></li>
        <li><CheckIcon size="20"/><span>Upload your genealogy database directly</span></li>
        <li><span class="note">Try the Sync app later</span></li>
      </ul>

      <router-link to="/sync/new/syncapp" class="btn btn-choice card-syncapp">
        <div class="method-title">Use the Sync app</div>
        <div class="method-subtitle">(recommended)</div>
        <img src="@/assets/logos/Sync_app.png" alt="" class="method-icon"/>
      </router-link>
      <ul v-show="showFeaturesRef" class="method-features features-syncapp list-unstyled">
        <li><CheckIcon size="20"/><span>FREE</span></li>
        <li><CheckIcon size="20"/><span>Easy to install</span></li>
        <li><CheckIcon size="20"/><span>No export to GEDCOM</span></li>
        <li><CheckIcon size="20"/><span>Upload your genealogy database directly</span></li>
        <li><StarIcon size="30"/><span class="better">Uploads your photos and documents too</span></li>
        <li><StarIcon size="30"/><span class="better">Easy to update your online tree over time</span></li>
      </ul>
    </div>
    <button v-show="!showFeaturesRef" type="button" class="btn btn-link choose-help"
      @click="showFeaturesRef = true">
      Which one should I choose?
    </button>
  </TaskPage>
</template>

<style lang="scss" scoped>
h5 {
  margin: 1rem 0 2rem;
}

.method-grid {
  padding: 0 2rem;
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr;
  grid-template-areas:
    "card-file"
    "card-syncapp";

  &.show-features {
    grid-template-areas:
      "card-file"
      "features-file"
      "card-syncapp"
      "features-syncapp";
  }

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "card-file card-syncapp";
    column-gap: 3rem;
    row-gap: 2rem;

    &.show-features {
      grid-template-areas:
        "card-file     card-syncapp"
        "features-file features-syncapp";
    }
  }
}

.choose-help {
  margin: 1rem 0 0 2rem;
  padding-left: 0;
}

.card-file { 
  grid-area: card-file;

  .method-icon {
    position: relative;

    img {
      width: 45px;
    }

    .feather-arrow-up {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 30px;
      height: 30px;
    }
  }
}

.card-syncapp { grid-area: card-syncapp; }
.features-file { grid-area: features-file; }
.features-syncapp { grid-area: features-syncapp; }

.btn-choice {
  border-radius: 12px;
  padding: 1rem 1rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .method-title {
    font-size: 1rem;
  }

  .method-subtitle {
    min-height: 1.5rem;
    font-size: 0.875rem;
    color: #888;
  }

  .method-icon {
    margin-top: 0.5rem;
    width: 60px;
    height: 60px;
    object-fit: contain;
  }

  .method-desc {
    margin: 0;
    font-size: 0.875rem;
    color: #888;
  }
}

.method-features {
  margin: 0;
  padding: 0 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #888;

  li {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .feather-check {
    transform: translateY(2px);
    flex-shrink: 0;
    color: var(--bs-success);
    stroke-width: 3px;
  }

  .feather-star {
    color: rgb(255, 183, 0);
    fill: rgb(255, 204, 0);
  }

  .note {
    margin-top: 1rem;
  }

  .better {
    color: #000;
  }
}

</style>

<script setup lang="ts">
import { ref } from 'vue'
import { usePageTitle } from '@webapp/util/AppUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import { ArrowUpIcon, CheckIcon, StarIcon, UploadIcon } from '@zhuowenli/vue-feather-icons'

const emit = defineEmits(['choose-file'])

const showFeaturesRef = ref(false)

usePageTitle('Upload my tree')
</script>
